import Swiper from 'swiper';
import { Navigation, Pagination, Keyboard, EffectFade } from 'swiper/modules';

export default class MediaCarousel {
	constructor(elm) {

		this.elm = elm;
		this.buttonPrev = this.elm.querySelector('[data-swiper-button-prev]');
		this.buttonNext = this.elm.querySelector('[data-swiper-button-next]');
		this.pagination = this.elm.querySelector('[data-swiper-pagination]');
		this.videos = this.elm.querySelectorAll('video');


		this.init();
	}

	init() {

		const self = this;

		this.swiper = new Swiper(this.elm, {
			modules: [Navigation, Pagination, Keyboard, EffectFade],
			init: false,
			slideClass: 'swiper-slide',
			slidesPerView: 1,
			keyboard: {
				enabled: true,
				onlyInViewport: true,
			},
			navigation: {
				prevEl: this.buttonPrev,
				nextEl: this.buttonNext
			},
			pagination: {
				el: this.pagination,
				clickable: true
			},
			effect: 'fade',
			fadeEffect: {
				crossFade: true,
			},
		});

		this.swiper.init();


		this.swiper.on('slideChange', function() {
			// stop videos in slider
			if(self.videos) {
				self.videos.forEach(video => {
					video.pause();
				});
			}
		});
	}
}